import React from 'react'
import Card from '../../components/card'
import { withRouter } from 'react-router-dom'

import { AuthContext } from '../../main/authProvider'
import TransactionService from '../../app/service/estoque/transactionService'
import GeneralServices from '../../app/service/generalServices'
import TransactionByNFTable from '../transactions/transactionByNFTable'
import ProgressService from '../../app/service/progressService'
import NFService from '../../app/service/estoque/NFService'
// import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import ConstantsUtil from '../../context/constantsUtil'
// import { Button } from 'primereact/button'
import ConfiguracaoEmpresaService from '../../app/service/configuracaoEmpresaService'
import HandleErrorService from '../../app/service/handleErrorService'
import NFseTable from '../../components/nfse/nfseTable'

class ValidacaoNFsServico extends React.Component {

    constructor(){
        super();
        this.generalServices = new GeneralServices();
        this.progressService = new ProgressService();
        this.transactionService = new TransactionService();
        this.NFService = new NFService();
        this.configuracaoEmpresaService = new ConfiguracaoEmpresaService();
    }

    state = {
        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',
        
        habilitaBusca: true,
    }

    componentDidMount(){
        // this.checaConfigucarao()
        this.autoSearch()
    }

    autoSearch = async () => {
        await this.generalServices.sleep(100)
        this.search()
    }

    search = () => {
        this.setState({habilitaBusca: false})
    }

    render() {

        const renderTable = () => {
            if(!this.state.habilitaBusca){
                return (
                    <NFseTable
                        validateNFs
                    />
                )
            }
        }

        return (
                   
            <div className="bs-docs-section" >
                
                <Card title = {"Validação das NFs de Serviço"}>

                    {renderTable()}

                </Card>
                <div className="d-flex "/>
            </div>
              
        )
    }


}

ValidacaoNFsServico.contextType = AuthContext

export default withRouter(ValidacaoNFsServico)